import React, { PureComponent } from "react";
import Form from "js/pages/Admin/Programa/ProductoCodificado/Edit/MyForm.js";
import AppQraphQL from "js/graphql/resolvers/productoCodificado.resolver";
import { removeTypename } from "js/utils/Helper";
import SegmentosGraphQL from "js/graphql/resolvers/segmento.resolver";

class Edit extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        idPrograma: this.props.match.params.id
      },
      segmentos: [],
      disabled: false,
      errors: null,
      id: this.props.match.params.id,
      codigoProducto: this.props.match.params.codigoProducto
    };
  }

  async componentDidMount() {
    const { client } = this.props;
    const { id, codigoProducto } = this.state;

    if (codigoProducto !== "new") {
      await client
        .query({
          query: AppQraphQL.queries.getProductoCodificado,
          fetchPolicy: "network-only",
          variables: {
            productoLike: {
              idPrograma: parseInt(id) || id,
              codigo: decodeURIComponent(codigoProducto)
            }
          }
        })
        .then(res => {
          const producto = res.data.getProductosCodificados.itemsPagina[0];
          this.setState({
            initialValues: {
              ...producto,
              fields: producto.puntosPorSegmentos
            }
          });
        });
    } else {
      this.setState({
        initialValues: {
          idPrograma: id,
          estado: "ACTIVO"
        }
      });
    }

    await client
      .query({
        query: SegmentosGraphQL.queries.getSegmentosInput,
        fetchPolicy: "network-only",
        variables: {
          idPrograma: parseInt(id) || id
        }
      })
      .then(res => {
        const segmentos = res.data.getSegmentos ? res.data.getSegmentos : null;
        this.setState({ segmentos });
      });
  }

  async submit(values) {
    const { client, history } = this.props;
    const { id, codigoProducto } = this.state;

    let variables = { ...values };
    variables.puntosPorSegmentos = variables.fields;
    delete variables.fields;

    variables.idPrograma = parseInt(variables.idPrograma);

    if (
      variables.puntosPorSegmentos &&
      variables.puntosPorSegmentos.length > 0
    ) {
      for (let item of variables.puntosPorSegmentos) {
        item.puntos = parseInt(item.puntos) || item.puntos;
      }
    }

    await client
      .mutate({
        mutation:
          codigoProducto === "new"
            ? AppQraphQL.mutations.createProductoCodificado
            : AppQraphQL.mutations.updateProductoCodificado,
        variables: {
          producto: { ...removeTypename(variables) }
        }
      })
      .then(res => {
        const mensaje =
          "Producto " +
          (codigoProducto === "new" ? "creado" : "modificado") +
          " correctamente";
        this.props.openNotification(mensaje);
        history.push(`/admin/programa/${id}/productos-codificados`);
      })
      .catch(errors => {
        const arr = [];
        arr.push({ message: "Error inesperado" });
        this.setState({
          errors: errors.graphQLErrors.length !== 0 ? errors.graphQLErrors : arr
        });
        return false;
      });
  }

  handleDateChange = key => date => {
    this.setState({
      [key]: date.toISOString()
    });
  };

  render() {
    return (
      <Form
        id={this.state.id}
        codigoProducto={this.state.codigoProducto}
        errors={this.state.errors}
        disabled={this.state.disabled}
        initialValues={this.state.initialValues}
        onSubmit={this.submit.bind(this)}
        segmentos={this.state.segmentos}
      />
    );
  }
}

export default Edit;
